import {BaseService} from "./BaseService";
import {ApiResponse} from "../../shared/models/ApiResponse";

export class InvestService extends BaseService {

    /**
     * save / create invest in an ag.
     * @param agId
     * @param amount
     * @param email
     * @param portfolioId
     * @param userId
     */
    async saveInvest(agId: string, amount: number, email: string, portfolioId: number, userId: string) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/partnerportal/v1/invest/save-invest/' + userId, {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify({
                    invest: {
                        account: agId,
                        amount: amount,
                        email: email,
                        portfolioId: portfolioId
                    }
                })
            }).then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(apiResponse);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }
}
